<template>
  <div class="page-setting">
    <div class="set-cont" v-loading="loading">

      <div class="item clearfix">
        <div class="left-tit">加好友权限</div>
        <div class="right-deta qx-wrap">
          <div class="select-item">
            <span class="tip">哪些人可以申请好友</span>
            <el-select class="riri-ipt" @change="selectCanAddChanged" v-model="canAddOptionsValue" placeholder="请选择">
              <el-option
                v-for="item in canAddOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-item">
            <span class="tip">不接受哪些人的申请</span>
            <el-select class="riri-ipt" @change="selectNotAddChanged" v-model="canNotAddOptionsValue" placeholder="请选择"  >
              <el-option
                v-for="item in canNotAddOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="item clearfix">
        <div class="left-tit">绑定第三方账号</div>
        <div class="right-deta bd-wrap clearfix">
          <div class="bd-item clearfix" v-if="!boundWeiXin" @click="bind(2)">
            <div class="img">
              <img :src="require('@/assets/images/bangding_01.jpg')" alt="">
            </div>
            <div class="rig">
                <p class="named"><a class="named" href="https://open.weixin.qq.com/connect/qrconnect?appid=wx9889a16d40aac1b8&redirect_uri=http%3a%2f%2fwww.renrendonghua.com%2fauth%2fauthWeiXin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect">微信绑定</a></p>
              <p class="jiechu"></p>
            </div>
          </div>
          <div class="bd-item clearfix" v-if="boundWeiXin" @click="unbind(2)">
            <div class="img">
              <img :src="require('@/assets/images/bangding_01.jpg')" alt="">
            </div>
            <div class="rig">
              <p class="named">解除绑定</p>
              <p class="jiechu"></p>
            </div>
          </div>
          <div class="bd-item clearfix" v-if="!boundQQ" @click="bind(0)">
            <div class="img">
              <img :src="require('@/assets/images/bangding_03.jpg')" alt="">
            </div>
            <div class="rig">
              <p class="named" @click="qqLoginClick" id="qqLoginBtn">QQ绑定</p>
              <p class="jiechu"></p>
            </div>
          </div>
          <div class="bd-item clearfix" v-if="boundQQ" @click="unbind(0)">
            <div class="img">
              <img :src="require('@/assets/images/bangding_03.jpg')" alt="">
            </div>
            <div class="rig">
              <p class="named">解除绑定</p>
              <p class="jiechu"></p>
            </div>
          </div>
          <div class="bd-item clearfix" v-if="!boundWeiBo" @click="bind(1)">
            <div class="img">
              <img :src="require('@/assets/images/bangding_02.jpg')" alt="">
            </div>
            <div class="rig">
                <p class="named"><a href="https://api.weibo.com/oauth2/authorize?client_id=2471057307&response_type=code&redirect_uri=http://www.renrendonghua.com/auth/authWeiBo" class="named">微博绑定</a></p>
              <p class="jiechu"></p>
            </div>
          </div>
          <div class="bd-item clearfix" v-if="boundWeiBo" @click="unbind(1)">
            <div class="img">
              <img :src="require('@/assets/images/bangding_02.jpg')" alt="">
            </div>
            <div class="rig">
              <p class="named">解除绑定</p>
              <p class="jiechu"></p>
            </div>
          </div>

<!--          <div class="bd-item clearfix active" v-if="boundWeiXin">-->
<!--            <div class="img">-->
<!--              <img :src="require('@/assets/images/bangding_03.jpg')" alt="">-->
<!--            </div>-->
<!--            <div class="rig">-->
<!--              <p class="named">人人动画</p>-->
<!--              <p class="jiechu">（解绑）</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="item clearfix">
        <div class="left-tit">修改密码</div>
        <div class="right-deta qx-wrap">
          <div class="select-item">
            <span class="tip ps">原有密码</span>
            <el-input type="password" v-model="password" class="riri-ipt" placeholder="请输入原密码" clearable ></el-input>
          </div>
          <div class="select-item">
            <span class="tip ps">新密码</span>
            <el-input type="password" v-model="newPassword" class="riri-ipt" placeholder="请输入新密码" clearable ></el-input>
          </div>
          <div class="tips-pass">*密码需由字母、数字、符号组合而成，不少于8位。</div>
          <div class="select-item">
            <span class="tip ps">确认新密码</span>
            <el-input type="password" v-model="rePassword" class="riri-ipt" placeholder="请确认新密码" clearable ></el-input>
          </div>
        </div>
      </div>
      <div class="last-btn">
        <el-button size="large" @click="changePassword">重置密码</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios';
  import vue from 'vue';
  vue.prototype.$axios = axios;
  import qs from 'qs';
  vue.prototype.qs = qs;
  import global from "../../api/global";
  import updateTdk from "@/utils/tdk";

export default {
  name:"setting",
  components: {

  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  data () {
    return {
      headTitle: "人人动画网【官网】",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      fromUrl:"",
      loading:false,
      id:null,
      boundWeiXin:false,
      boundQQ:false,
      boundWeiBo:false,
      canAddOptionsValue: 1,
      canAddOptions: [
        {
          value: 0,
          label: '所有人'
        },
        {
          value: 1,
          label: '共同关注作品类型'
        },
        {
          value: 2,
          label: '同一地域'
        },
        {
          value: 3,
          label: '我的好友添加过好友印象的人'
        },
        {
          value: 4,
          label: '我的好友认可过个人标签的人'
        }
      ],
      canNotAddOptionsValue: 1,
      canNotAddOptions: [
        {
          value: 0,
          label: '默认'
        },
        {
          value: 1,
          label: '基本资料不完整'
        },
        {
          value: 2,
          label: '高级资料不完整'
        }
      ],
      canNotAddValue: '',
      password: '',
      newPassword: '',
      rePassword: ''
    }
  },
  serverPrefetch() {
    this.setSeo();
    updateTdk.call(this);
  },
  mounted() {
    this.isMounted = true;

    setTimeout(()=>{
        // console.log("==================this.global.isLogin====",this.global)
        // console.log("this.fromUrl","http://www.renrendonghua.com/setting")
        this.$cookies.set("formUrl","http://www.renrendonghua.com/setting",60 * 60,"/",process.env.VUE_APP_DOMAIN);
        // console.log("==================his.$cookies====",this.$cookies)
        this.checkIsLogin();
      },1000)

  },
  methods:{
    setSeo() {
      this.headTitle = "设置——人人动画网【官网】";
      this.headKeywords = "设置——人人动画网,动画短视频,短视频";
      this.headDesc ="设置——人人动画网，是一个动画短视频分享社区，凭借丰富的快速动画创意资源，和行业深厚的动画技术背景，助力每个人实现自己的动画梦。";
    },
      qqLoginClick() {
          // 直接弹出授权页面，授权过后跳转到回调页面进行登录处理
          // eslint-disable-next-line no-undef
          QC.Login.showPopup({
              appId:"101866307",
              redirectURI:"http://www.renrendonghua.com/auth/authQQ"  //登录成功后会自动跳往该地址
          });
          // this.timer = setInterval(this.checkQQLogin, 1000);
      },
    //检查是否绑定第三方
    checkThirdPartUser(){
      let that=this;
      let url="/api/auth/isBound?tem="+new Date().getMilliseconds();
      that.$axios.get(url).then(function (result) {
        that.boundWeiBo=result.data.response.boundWeiBo;
        that.boundQQ=result.data.response.boundQQ;
        that.boundWeiXin=result.data.response.boundWeiXin;
        console.log(result.data.response)
      })
    },
    //修改密码
    changePassword(){
      let that=this;
      that.loading=true;

      if(!that.password){
        that.$message({
          message: '旧码不能为空',
          type: 'warning'
        });
        that.loading=false;
        return false;
      }
      let reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,44}$/
      if(!that.newPassword){
        that.$message({
          message: '新密码不能为空',
          type: 'warning'
        });
        that.loading=false;
        return false;
      }else if(that.newPassword.length<8){
        that.$message({
          message: '密码要大于8位',
          type: 'warning'
        });
        that.loading=false;
        return false;
      }else if(that.newPassword.length>44){
        that.$message({
          message: '密码过长',
          type: 'warning'
        });
        that.loading=false;
        return false;
      }else if(!reg.test(that.newPassword)){
        that.$message({
          message: '密码必须是字母，数字或字符组合',
          type: 'warning'
        });
        that.loading=false;
        return false;
      }else if(that.newPassword!=that.rePassword){
        that.$message({
          message: '密码与确认密码不一致',
          type: 'warning'
        });
        that.loading=false;
        return false;
      }
      let url="/open/password/changePassword?tem="+new Date().getMilliseconds();
      let postData={
        password:that.password,
        newPassword:that.newPassword,
      }
      that.$axios.post(url,qs.stringify(postData)).then(function (result) {

        if(result.data.code==1){
          that.$message({
            message: '修改成功',
            type: 'success'
          });
        }else {
          that.$message({
            message: result.data.message,
            type: 'error'
          });
        }
        that.loading=false;
      })
    },
    //检查是否登录
    checkIsLogin(){
      if(this.global.isLogin){
        this.getPrivacy();
        this.checkThirdPartUser();
      }else{
        this.$router.push("/login?callback="+window.location.href);
      }
    },
    //获取好友权限
    getPrivacy(){
      let url="/rrbi/privacy/privacy-one?tem="+new Date().getMilliseconds();
      let that=this;
      that.$axios.get(url).then(function (result) {
          that.canAddOptionsValue=result.data.response.permitScope;
          that.canNotAddOptionsValue=result.data.response.refuseScope;
          that.id=result.data.response.id
          console.log("privacy",result);
      })
    },
    //更改好友权限
    selectCanAddChanged(val){
      let that=this;
      let url="/rrbi/privacy/privacy-update?tem="+new Date().getMilliseconds();
      let data={
        id:that.id,
        permitScope:val
      }
      that.$axios.post(url,qs.stringify(data)).then(function (result) {
        console.log("result.data.code",result.data.code)
        if(result.data.code==1){
          that.$message.success("设置成功")
        }
      })
    },
    selectNotAddChanged(val){
      let that=this;
      let url="/rrbi/privacy/privacy-update?tem="+new Date().getMilliseconds();
      let data={
        id:that.id,
        refuseScope:val
      }
      that.$axios.post(url,qs.stringify(data)).then(function (result) {
        if(result.data.code==1){
          that.$message.success("设置成功")
        }
      })
    },
    bind(val){

    },
    unbind(val){
      let that=this;
      let url="/api/auth/unbind?type="+val+"&tem="+new Date().getMilliseconds()
      let message="";
      if(val==0){
          message="QQ"
      }else if(val==1){
          message="微博"
      }else if(val==2){
          message="微信"
      }
        this.$confirm('确定解绑'+message+', 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.get(url).then(function (result) {
                if(result.data.code==1){
                    that.$message.success("解绑成功")
                    that.checkThirdPartUser();
                }else{
                    that.$message.error("解绑失败")
                }

            })
        }).catch(() => {
            console.log("quxiaocaozuo")
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
        });

    },
  }
}
</script>

<style scoped lang="less">
.page-setting{
  padding-top: @NAVHEIGHT + 30;
  padding-bottom: 30px;
  background: #fff;
  .set-cont{
    overflow: hidden;
    margin: 0 auto;
    width: 900px;
    .item{
      margin-bottom: 30px;
      .left-tit{
        float: left;
        padding: 10px 50px 0 0;
        width: 200px;
        text-align: right;
        font-size: 16px;
      }
      .right-deta{
        float: right;
        width: 670px;
        &.black-list{
          background: #f5f5f5;
          .black-item{
            padding: 18px;
            border-bottom: 1px solid #fdfdfd;
            .left{
              margin-right: 70px;
              .avatar{
                float: left;
                display: block;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background-size: cover;
              }
              .infoes{
                margin-left: 60px;
                .name{
                  display: block;
                  font-weight: bold;
                  font-size: 16px;
                  color: #000;
                }
                .inf{
                  margin-top: 4px;
                  display: block;
                  font-size: 14px;
                }
              }
            }
            .right{
              float: right;
            }
          }
          .more-item{
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #878787;
            cursor: pointer;
          }
        }
        &.qx-wrap{
          .select-item{
            margin-top: 5px;
            margin-bottom: 15px;
            &:last-child{
              margin-bottom: 0;
            }
            .tip{
              margin-right: 10px;
              line-height: 32px;
              font-size: 14px;
              &.ps{
                display: inline-block;
                width: 80px;
                text-align: right;
              }
            }
            .riri-ipt{
              width: 300px;
            }
          }
          .tips-pass{
            margin-left: 90px;
            margin-bottom: 8px;
            margin-top: -5px;
            font-size: 12px;
            color: #a3a3a3;
          }
        }
        &.bd-wrap{
          .bd-item{
            float: left;
            width: 33%;
            .img{
              float: left;
              width: 54px;
              height: 54px;
            }
            .rig{
              float: left;
              .named{
                margin: 15px 0 15px 10px;
                color: #118fda;
                line-height: 24px;
                cursor: pointer;
              }
            }
            &.active{
              .rig{
                padding-top: 3px;
                .named{
                  margin: 0 0 0 10px;
                  color: #6b6b6b;
                }
                .jiechu{
                  margin-top: 4px;
                  line-height: 20px;
                  font-size: 14px;
                  color: #a2a2a2;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
    .last-btn{
      text-align: center;
    }
  }
}
@media screen and (max-width: 900px) {
  .page-setting{
    padding-top: @NAVHEIGHT + 10;
    padding-right: 10px;
    padding-left: 10px;
    .set-cont{
      width: 100%;
      .item{
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
        .left-tit{
          float: none;
          padding: 0;
          width: 100%;
          text-align: left;
          font-size: 16px;
          font-weight: bold;
        }
        .right-deta{
          float: none;
          width: 100%;
          &.black-list{
            .black-item{
              padding: 10px 5px;
              .left{
                .infoes{
                  .name{
                    font-size: 14px;
                  }
                  .inf{
                    font-size: 12px;
                  }
                }
              }
            }
          }
          &.qx-wrap{
            .select-item{
              display: flex;
              .tip{
                font-size: 12px;
              }
              .riri-ipt{
                flex: 1;
              }
            }
          }
          &.bd-wrap{
            display: flex;
            margin-top: 5px;
            .bd-item{
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .img{
                float: none;
              }
              .rig{
                float: none;
                .named{
                  margin: 0;
                }
                .jiechu{
                  height: 20px;
                }
              }
              &.active{
                .rig{
                  padding: 0;
                  .named{
                    margin: 0;
                  }
                  .jeichu{
                    margin: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
